export default __webpack_public_path__ + "static/media/Background_00188.f4d0ffd6.png";